import { render } from "./FormLogin.vue?vue&type=template&id=b03228e0"
import script from "./FormLogin.vue?vue&type=script&lang=js"
export * from "./FormLogin.vue?vue&type=script&lang=js"
script.render = render

export default script